import { HttpAuthorizationType } from "processEditor/components/Triggers/HttpTrigger";
import { ElementType, IElement } from "../IProcessData";
import { IHttpTrigger, Triggers } from "../ITriggerData";
import { IMigrationParameters } from "./index";

export function migrate(migrateParameters: IMigrationParameters) {
    const element = migrateParameters.element;
    if (element &&
        element.type === ElementType.Start &&
        isHttpTrigger(element)) {

        const existingParams = element.parameters as _OBSOLETE_IHttpApiTriggerWithOAuth2Options;
        if (existingParams.auth && hasObsoleteAuthType(existingParams.auth)) {

            const migratedParameters = Object.assign<object, _OBSOLETE_IHttpApiTriggerWithOAuth2Options, Partial<_OBSOLETE_IHttpApiTriggerWithOAuth2Options>>({}, existingParams, {
                auth: HttpAuthorizationType.ApiPolicy,
                "oAuth2Options": {}
            });

            // Exclude oAuth2Options from the new parameters
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const {oAuth2Options, ...rest} = migratedParameters;

            const migratedElement = Object.assign({}, element, { parameters: rest });
            return migratedElement;
        }
    }
    return element;
}

const isHttpTrigger = (element: IElement) => {
    return element.selectedTypeId === Triggers.HttpApiTrigger.triggerType || element.selectedTypeId === Triggers.HttpTrigger.triggerType;
}

const hasObsoleteAuthType = (authType: string): authType is _OBSOLETE_HttpAuthorizationType => {
    return Object.values(_OBSOLETE_HttpAuthorizationType).includes(authType as _OBSOLETE_HttpAuthorizationType);
}

export enum _OBSOLETE_HttpAuthorizationType {
    None = "None",
    ApiKey = "ApiKey",
    OAuth2 = "OAuth2"
}

export type _OBSOLETE_IHttpApiTriggerWithOAuth2Options = IHttpTrigger & {
    oAuth2Options?: object;
};